/** Yearly ATD tiles end in YYYY; daily weather tiles end in YYYYMMDD. */
export function isYearlyWeatherLayerName(geoServerName: string | null | undefined): boolean {
  if (!geoServerName) {
    return false;
  }
  return /\d{4}$/.test(geoServerName) && !/\d{8}$/.test(geoServerName);
}

/**
 * Deviation / Normal / Anomalies stay out of DATA_TYPE weather.
 * Yearly deviation tiles (EraDeviationSumOfFallout2026) belong to DATA_TYPE deviation.
 */
export function isExcludedFromWeatherDataType(geoServerName: string | null | undefined): boolean {
  if (!geoServerName) {
    return true;
  }
  return geoServerName.includes('Normal')
    || geoServerName.includes('Anomalies')
    || geoServerName.includes('Deviation');
}

/**
 * Strip trailing YYYYMMDD or YYYY and source/type tokens so the same indicator
 * can be rematched after a date or year change.
 */
export function stripWeatherLayerPeriod(layerName: string | null | undefined): string {
  if (!layerName) {
    return '';
  }
  // Source token is anchored to the start: an unanchored /Era/ would also strip "era" out of "Temperature".
  return layerName
    .replace(/\d{8}$/, '')
    .replace(/\d{4}$/, '')
    .replace(/_/g, '')
    .replace(/^(Era5?|Ibm|Ugm)/i, '')
    .replace(/^(Deviation|Normalized|Normal|Weather)/i, '');
}
